import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

// Styles
import styles from "./IconButton.css";

// Constants
export const DATA_HOOK = "IconButton";

function IconButton({ children, className, onClick, tabIndex = -1 }) {
  return (
    <button className={classnames(styles.root, className)} onClick={onClick} tabIndex={tabIndex}>
      {children}
    </button>
  );
}

IconButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};

export default IconButton;
